import { Spinner, Toggle } from '@/components/ui'
import DataContainer from '../../common/DataContainer'
import { formatDate, formatPrice } from '@/utils/formatters'
import { useBienContext } from "@/features/biens/BienContext"

export default () => {
  const { bien, loading } = useBienContext()

  const mandat = bien.mandats.find( m => m.type_mandat === "vente")
  
  return (
    <div className='overflow-hidden mb-4'>
      <h3 className="text-md font-semibold mb-2">
        Informations générales sur la vente 
      </h3>
      <div className={`w-full bg-primary-100 p-4 rounded-none`}> 
        { loading && <Spinner /> }
        { !loading && <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 2xl:grid-cols-2 gap-5"> 
          <div className="flex flex-col gap-4">
            { (bien.prix_vente || !mandat?.date_fin)  && 
                <DataContainer label="Prix de vente affiché" value={formatPrice(bien.prix_vente)} />
            }
            { (bien.vente_montant_honoraires_ttc > 0 || !mandat?.date_fin)  && 
                <DataContainer label="Montant des honoraires" value={formatPrice(bien.vente_montant_honoraires_ttc)} />
            }
            { (bien.montant_net_vendeur  > 0|| !mandat?.date_fin) &&
                <DataContainer label="Prix net vendeur" value={formatPrice(bien.montant_net_vendeur)} />
            }
            <DataContainer label="Mandat n°" value={mandat?.numero} />
            <DataContainer label="Date mandat" value={formatDate(mandat?.date_signature)} />
            {
              mandat?.date_fin && <DataContainer label="Date de fin du mandat" value={formatDate(mandat?.date_fin)} />
            }
          </div>

          <div className="flex flex-col gap-4">
            { !mandat?.date_fin && 
                <div className="grid grid-cols-[13rem_1fr] items-center gap-2">
                  <div className="text-gray-600 whitespace-nowrap">Clé à l'agence :</div>
                  <Toggle.Display labelSuffix="" className="mb-0" value={bien.cle_dispo} />
                </div>
            }
            { (bien.date_signature_compromis || !mandat?.date_fin) &&
                <DataContainer label="Date compromis" value={formatDate(bien.date_signature_compromis)} />
            }
            { (bien.date_signature_acte || !mandat?.date_fin)  &&
                <DataContainer label="Date signature" value={formatDate(bien.date_signature_acte)} />
            }
            { (bien.date_releve_compteur || !mandat?.date_fin)  && 
                <DataContainer label="Date relevé de compteur" value={formatDate(bien.date_releve_compteur)} />
            }
          </div>
        </div> }
      </div>
    </div>
  )
}